module.exports = __webpack_public_path__ + "static/media/addnew.d427f8dc.svg";